import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ObjectUtils } from "~app/common/utils/object-utils";

@Injectable()
export class NavigationService {
    avtalId$ = new BehaviorSubject<number>(null);
    kontraktId$ = new BehaviorSubject<number>(null);
    atgardId$ = new BehaviorSubject<number>(null);

    navigate(avtalId?: string, kontraktId?: string, atgardId?: string) {
        if (ObjectUtils.hasValue(avtalId)) {
            this.avtalId$.next(parseInt(avtalId, 10));
        }
        if (ObjectUtils.hasValue(kontraktId)) {
            this.kontraktId$.next(parseInt(kontraktId, 10));
        }
        if (ObjectUtils.hasValue(atgardId)) {
            this.atgardId$.next(parseInt(atgardId, 10));
        }
    }
}
